export const STORAGE_CWID = 'idt_display_cwid'
export const STORAGE_ROLE_NAME = 'idt_display_user_name'
/** 经度 */
export const STORAGE_LNG = 'idt_display_longitude'
/** 纬度 */
export const STORAGE_LAT = 'idt_display_latitude'
/** 根据身份决定的固定状态 */
export const STORAGE_FIXED_STATUS = 'idt_display_fixed_status'
/** 用户的身份数字 */
export const STORAGE_ROLE_ID = 'idt_display_role_id'
